import { memo, useContext, useState, useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { Text, useTheme, Chip } from '@Sage/hoi-poi-ui';
import { CopilotSidebar, CopilotContext } from '@Sage/ssm-web5';
import { getCopilotActions } from 'utils/copilotActions';

import SageCopilotIcon from '../../../lib/metadata/icons/SageCopilot';

import './styles.scss';

const menuOnClass = 'copilot-sidebar--on';
const localStorageKey = 'CopilotSidebarOn';

const CopilotSidebarTrigger = () => {
    const { getMethodsForCopilot } = useContext(CopilotContext);
    const { userData } = useSelector((state) => ({ userData: state.config.userData || {} }));
    const [isOpen, setIsOpen] = useState(window.localStorage.getItem(localStorageKey) !== null);
    const theme = useTheme();

    useEffect(() => {
        getMethodsForCopilot.registerFeatureMethods('ssm', {
            'show-entity-detail': getCopilotActions('show-entity-detail'),
        });
    }, [getMethodsForCopilot]);

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add(menuOnClass);
            window.localStorage.setItem(localStorageKey, true);
        } else {
            document.body.classList.remove(menuOnClass);
            window.localStorage.removeItem(localStorageKey);
        }
    }, [isOpen]);

    const triggerSidebar = useCallback(() => {
        setIsOpen((current) => !current);
    }, []);

    const sidebarProps = useMemo(
        () => ({
            onClose: triggerSidebar,
            userData,
        }),
        [triggerSidebar, userData],
    );

    return (
        <>
            <div className="copilot-sidebar-trigger" onClick={triggerSidebar}>
                <Chip
                    type="text"
                    size="large"
                    className={
                        !isOpen
                            ? 'copilot-sidebar-trigger__button'
                            : 'copilot-sidebar-trigger__button--open'
                    }
                    overrides={{
                        Text: {
                            style: {
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            },
                        },
                    }}
                >
                    <div
                        className={
                            !isOpen
                                ? 'copilot-sidebar-trigger__icon'
                                : 'copilot-sidebar-trigger__icon--open'
                        }
                    >
                        <SageCopilotIcon />
                    </div>
                    <Text color={theme.colors.primary.black}>Copilot</Text>
                </Chip>
            </div>

            <div
                className={classnames('copilot-sidebar-container', {
                    'copilot-sidebar-container--opened': isOpen,
                })}
            >
                <CopilotSidebar {...sidebarProps} />
            </div>
        </>
    );
};

export default memo(CopilotSidebarTrigger);
